import { formatPrice } from 'shared-constants'

export const getPriceToAxisLabelFormatter =
  (totalPrice, currency) => (price) => {
    let unit = ''
    let divisor = 1
    if (totalPrice >= 2000000) {
      unit = 'M'
      divisor = 1000000
    } else if (totalPrice >= 2000) {
      unit = 'k'
      divisor = 1000
    }
    return `${formatPrice({
      currency,
      price: price / divisor,
      roundToInteger: true,
    })}${unit}`
  }

export const getPriceByCurrencyIsoCodeFromCalculatedPrices = (
  currencyIsoCode,
  calculatedPrices
) => calculatedPrices.find((price) => price.currencyIsoCode === currencyIsoCode)
